export { default as DetailedRouteModal } from "./DetailedRouteModal";
export type { DetailedRouteLoadDetail, DetailedRouteModalProps } from "./DetailedRouteModal";
